import PropTypes from 'prop-types';
import React, { useEffect } from 'react';

const ConnectionLost = ({
  team,
  csrfToken,
  confirm,
  onRestart
}) => (
  <div className="row"
       style={{"paddingTop": "200px", "paddingBottom": "200px"}}>
    <div className="col-12 text-center">
      <p className="mb-2" style={{"fontSize": "21px"}}>
        <strong>Oops! You've been disconnected!</strong>
      </p>
      <p className="mb-3 text-muted" style={{"fontSize": "14px"}}>
        Your session ended due to inactivity. Please reload the page to reconnect.
      </p>
      <p className="mb-0" style={{"fontSize": "14px"}}>
        <a href="#"
           onClick={
             (e) => {
               e.preventDefault();
               if (onRestart) { onRestart(); return; }
               window.location.reload();
             }
           }>
          <strong>Reload Page</strong>
        </a>
      </p>
    </div>
  </div>
);

ConnectionLost.propTypes = {
  team: PropTypes.object.isRequired,
  csrfToken: PropTypes.string.isRequired,
  confirm: PropTypes.object.isRequired,
  onRestart: PropTypes.func
};

export default ConnectionLost;
